// ids of the corporate subscriptions
export const AppCorporateSubscriptions = ["corporate", "corporate_plus"]
